export class ReCaptchaAction {
  public static readonly login = 'LOGIN';
  public static readonly loginConfirm = 'LOGINCONFIRM';
  public static readonly register = 'REGISTER';
  public static readonly registerConfirm = 'REGISTERCONFIRM';
  public static readonly activation = 'ACTIVATION';
  public static readonly forgotPswSendCode = 'SENDCODE';
  public static readonly forgotPswVerifyCode = 'VERIFYCODE';
  public static readonly forgotPswReset = 'RESET';
}
